var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 48,
    viewBox: "0 0 72 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4C0.5 2.067 2.067 0.5 4 0.5H68C69.933 0.5 71.5 2.067 71.5 4V44C71.5 45.933 69.933 47.5 68 47.5H4C2.06701 47.5 0.5 45.933 0.5 44V4Z",
    fill: "white",
    stroke: "#DDDDDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 34.7317C33.5639 36.8321 30.4038 38.1 26.9508 38.1C19.246 38.1 13 31.7872 13 24C13 16.2128 19.246 9.89999 26.9508 9.89999C30.4038 9.89999 33.5639 11.1679 36 13.2683C38.4361 11.1679 41.5961 9.89999 45.0491 9.89999C52.7539 9.89999 58.9999 16.2128 58.9999 24C58.9999 31.7872 52.7539 38.1 45.0491 38.1C41.5961 38.1 38.4361 36.8321 36 34.7317Z",
    fill: "#ED0006"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 34.7317C38.9996 32.1455 40.9017 28.2973 40.9017 24C40.9017 19.7027 38.9996 15.8545 36 13.2683C38.4361 11.1679 41.5961 9.89999 45.0491 9.89999C52.754 9.89999 59 16.2128 59 24C59 31.7872 52.754 38.1 45.0491 38.1C41.5961 38.1 38.4361 36.8321 36 34.7317Z",
    fill: "#F9A000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0001 34.7314C38.9997 32.1452 40.9016 28.297 40.9016 23.9999C40.9016 19.7027 38.9997 15.8545 36.0001 13.2683C33.0006 15.8545 31.0986 19.7027 31.0986 23.9999C31.0986 28.297 33.0006 32.1452 36.0001 34.7314Z",
    fill: "#FF5E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.b6cf0d58f791c9441087baf47a567348.svg";
export { ForwardRef as ReactComponent };